/* Cart drawer banner. Fills the markup from the UpCart announcement template. */
(function () {
  'use strict';

  var BANNER_IS_CLICKABLE = false;

  var SECTION_ID = 'sh-upcart-banner';
  var HOST_ID = 'upCart';
  var CART_WRITE = /\/cart\/(add|change|update|clear)/;

  var HISTORY_KEY = 'shUpcartBannerOrder';
  var PREV_KEY = 'shUpcartBannerPrev';

  var cache = {};
  var currentData = null;
  var lastSignature = '';
  var wantHandle = null;
  var busy = false;
  var pending = false;
  var shadowWatched = false;

  var origFetch = window.fetch;

  // The add order, oldest first. The cart order is not the add order, so the
  // script keeps its own list. sessionStorage carries it between pages.
  function readOrder() {
    try { return JSON.parse(sessionStorage.getItem(HISTORY_KEY)) || []; }
    catch (e) { return []; }
  }

  function writeOrder(list) {
    try { sessionStorage.setItem(HISTORY_KEY, JSON.stringify(list.slice(-20))); }
    catch (e) {}
  }

  function pushOrder(handle) {
    var list = readOrder().filter(function (h) { return h !== handle; });
    list.push(handle);
    writeOrder(list);
  }

  // Previous cart contents, to find what was added.
  function readPrev() {
    try { return JSON.parse(sessionStorage.getItem(PREV_KEY)); }
    catch (e) { return null; }
  }

  function writePrev(map) {
    try { sessionStorage.setItem(PREV_KEY, JSON.stringify(map)); }
    catch (e) {}
  }

  // A new handle, or a higher quantity, means the customer added that product.
  // This does not depend on catching the add request.
  function detectAdds(items) {
    var now = {};
    var i;
    for (i = 0; i < items.length; i++) {
      now[items[i].handle] = (now[items[i].handle] || 0) + items[i].quantity;
    }

    var prev = readPrev();

    if (!prev) {
      // First read in this tab. Seed from the cart itself. /cart.js returns the
      // NEWEST item first, so walk it backwards to get oldest first.
      if (!readOrder().length) {
        for (i = items.length - 1; i >= 0; i--) pushOrder(items[i].handle);
      }
    } else {
      // Only a new handle counts. A higher quantity is a stepper click, and
      // that must not change the banner.
      for (var h in now) {
        if (!Object.prototype.hasOwnProperty.call(now, h)) continue;
        if (!prev[h]) pushOrder(h);
      }
    }

    writePrev(now);
  }

  // Wrap early. UpCart keeps its own reference to fetch.
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var req = arguments[0];
      var path = typeof req === 'string' ? req : (req && req.url) || '';
      var isWrite = CART_WRITE.test(path);

      return origFetch.apply(this, arguments).then(function (res) {
        if (isWrite) schedule();
        return res;
      });
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_WRITE.test(url)) {
      this.addEventListener('load', schedule);
    }
    return origOpen.apply(this, arguments);
  };

  // UpCart can render in a shadow DOM or in the main document. The mode is a
  // setting in the UpCart admin, so support both.
  function shadow() {
    var host = document.getElementById(HOST_ID);
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function find(suffix) {
    var id = '#sh-upcart-banner' + suffix;
    var root = shadow();
    return (root && root.querySelector(id)) || document.querySelector(id);
  }

  function hide() {
    var root = find('');
    if (root) root.hidden = true;
  }

  function paint(data) {
    var root = find('');
    var heading = find('-heading');
    var text = find('-text');
    var img = find('-img');
    var link = find('-link');
    if (!root) return;

    if (!data || !data.show) {
      root.hidden = true;
      return;
    }

    if (data.background) {
      var bg = 'url("' + data.background + '")';
      if (root.style.backgroundImage !== bg) root.style.backgroundImage = bg;
    }

    if (heading && heading.textContent !== data.heading) heading.textContent = data.heading;
    if (text && text.textContent !== data.text) text.textContent = data.text;

    if (img) {
      if (data.image) {
        if (img.getAttribute('src') !== data.image) img.setAttribute('src', data.image);
        img.hidden = false;
      } else {
        img.removeAttribute('src');
        img.hidden = true;
      }
    }

    if (link) {
      if (BANNER_IS_CLICKABLE && data.link) {
        link.setAttribute('href', data.link);
      } else {
        link.removeAttribute('href');
      }
    }

    if (root.hidden) root.hidden = false;
  }

  // Keep the locale prefix, or a translated storefront returns the base language.
  function root_url() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!r) return '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function loadBanner(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);

    var url = root_url() + 'products/' + encodeURIComponent(handle) +
      '?section_id=' + SECTION_ID;

    return origFetch.call(window, url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('section request failed');
        return r.text();
      })
      .then(function (html) {
        var node = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-sh-upcart-banner]');
        if (!node) return null;

        var data = {
          show: node.getAttribute('data-show') === '1',
          heading: node.getAttribute('data-heading') || '',
          text: node.getAttribute('data-text') || '',
          image: node.getAttribute('data-product-image') || '',
          background: node.getAttribute('data-background') || '',
          link: node.getAttribute('data-link') || ''
        };

        cache[handle] = data;
        return data;
      })
      .catch(function () { return null; });
  }

  function signature(items) {
    var parts = [];
    for (var i = 0; i < items.length; i++) {
      parts.push(items[i].key + ':' + items[i].quantity);
    }
    return parts.join(',') + '|' + readOrder().join('>');
  }

  // The newest added product that is still in the cart wins. The last line item
  // is only the fallback, for a cart the script never saw an add for.
  function pickHandle(items) {
    var inCart = {};
    for (var i = 0; i < items.length; i++) inCart[items[i].handle] = true;

    var list = readOrder();
    var kept = [];
    for (var j = 0; j < list.length; j++) {
      if (inCart[list[j]]) kept.push(list[j]);
    }
    if (kept.length !== list.length) writeOrder(kept);

    if (kept.length) return kept[kept.length - 1];
    // /cart.js returns the newest item first.
    return items.length ? items[0].handle : null;
  }

  function refresh() {
    if (busy) { pending = true; return; }
    if (!find('')) return;

    busy = true;

    origFetch.call(window, '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        detectAdds(items);
        var sig = signature(items);

        if (sig === lastSignature) {
          if (currentData) paint(currentData);
          return null;
        }
        lastSignature = sig;

        if (!items.length) {
          wantHandle = null;
          currentData = null;
          writeOrder([]);
          writePrev({});
          hide();
          return null;
        }

        var handle = pickHandle(items);
        if (!handle) { hide(); return null; }

        wantHandle = handle;

        return loadBanner(handle).then(function (data) {
          if (wantHandle !== handle) return;
          currentData = data;
          paint(data);
        });
      })
      .catch(function () { hide(); })
      .then(function () {
        busy = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  // UpCart repaints the drawer before the server confirms, so /cart.js can be
  // one step behind. Check again a moment later. refresh() does nothing when
  // the cart signature is unchanged.
  var scheduled = null;
  var verify = null;
  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(refresh, 150);
    if (verify) clearTimeout(verify);
    verify = setTimeout(refresh, 700);
  }

  // React clears the markup on every re-render, so watch and fill it again.
  // A shadow root needs its own observer. The main document does not report
  // changes inside it. Watch the document as well, for the non-shadow mode.
  function watchShadow() {
    if (shadowWatched) return;
    var root = shadow();
    if (!root) return;

    shadowWatched = true;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    schedule();
  }

  function watchAll() {
    watchShadow();

    new MutationObserver(function () {
      watchShadow();
      schedule();
    }).observe(document.documentElement, { childList: true, subtree: true });

    schedule();
  }

  // Take a first snapshot once per tab, so the first add is also detected.
  function seed() {
    if (readPrev()) return;
    origFetch.call(window, '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { detectAdds((cart && cart.items) || []); })
      .catch(function () {});
  }

  function start() {
    seed();
    watchAll();
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:refresh', schedule);
    window.addEventListener('pageshow', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
